import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_8 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_10 = { class: "col-lg-12 break-word" }
const _hoisted_11 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_12 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_13 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_14 = { class: "col-lg-12 break-word" }
const _hoisted_15 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_16 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_17 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_18 = { class: "col-lg-12 break-word" }
const _hoisted_19 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 mb-2 gx-3" }
const _hoisted_20 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_21 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_22 = { class: "col-lg-12 break-word" }
const _hoisted_23 = { class: "content-break break-spaces" }
const _hoisted_24 = { class: "mb-4 text-center fw-bold" }
const _hoisted_25 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_26 = {
  class: "modal fade",
  id: "editMessageTemplateSuccess",
  tabindex: "-1",
  "aria-labelledby": "editMessageTemplateSuccess",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editMessageTemplateSuccess"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_32 = {
  class: "my-4 text-center",
  id: "editMessageTemplateSuccess"
}
const _hoisted_33 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import { computed, onMounted, PropType, ref } from 'vue'
import Button from '@/components/button/index.vue'
import { useRoute } from 'vue-router'
import messageTemplateServices from '@/services/message-template.services'
import { pick } from 'lodash'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  formData: {
    type: Object,
    default: () => ({
      message_type: 0,
      name: '',
      title: '',
      content: '',
    }),
  },
  resetForm: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props, { expose }) {

const props = __props

const editFailed = ref<boolean>(false)


const route = useRoute()

// 2022/09/15 TienNV Fix double click button confirm edit
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('confirmModal'))
  modalSuccess.value = new Modal(document.getElementById('editMessageTemplateSuccess'))
})

expose({
  showConfirmModal: (): void => modalConfirm.value.show(),
})

const translateMessageType = computed(() => {
  switch (props.formData.message_type) {
    case 0:
      return translate('OE50sendAllMessages')
    case 1:
      return translate('sendInviteOnlyGroupInfo')
    default:
      return ''
  }
})

const loading = ref(false)

const submit = async (): void => {
  loading.value = true
  try {
    if (route.params?.id && route.params?.message_template_id) {
      const response = await messageTemplateServices.updateMessageTemplates({
        community_id: route.params?.id,
        template_id: route.params?.message_template_id,
        data: pick(props.formData, 'message_type', 'name', 'content', 'title'),
      })
      if (response?.status === 200) {
        editFailed.value = false
      } else {
        editFailed.value = true
      }
      //2022/09/15 TienNV Fix double click button confirm edit
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        loading.value = false
      }, 2000)
    }
  } catch (error) {
    editFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('editMessageTemplate')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('templateType')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translateMessageType)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)('templateName')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(__props.formData.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('title')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(__props.formData.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('content')), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", _hoisted_23, _toDisplayString(__props.formData.content), 1)
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(translate)('CD40textConfirm')), 1),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'me-2 fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: 'secondary',
                className: 'fw-bold',
                onClick: submit,
                loading: loading.value,
                disabled: loading.value
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h5", _hoisted_30, _toDisplayString(_unref(translate)('editMessageTemplate')), 1),
            _hoisted_31
          ]),
          _createElementVNode("p", _hoisted_32, _toDisplayString(editFailed.value ? _unref(translate)('CD40notUpdated') : _unref(translate)('updateComplete')), 1),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})